import { render, staticRenderFns } from "./ViStudentHome.vue?vue&type=template&id=72f8248a&scoped=true"
import script from "./ViStudentHome.vue?vue&type=script&lang=js"
export * from "./ViStudentHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f8248a",
  null
  
)

export default component.exports